module.exports = __webpack_public_path__ + "static/media/shareLockGuide3_Jap.bc421042.jpg";